(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('scheduleFilter', scheduleFilter);

    function scheduleFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                objectType: '&',
                objectTypeVal: '&',
                fleet: '&',
                fleetVal: '&',
                fromVal: '&',
                toVal: '&',
                status: '&',
                statusVal: '&',
                tagVal: '&'
            },
            template:
            // '<div class="row">\n' +
            // '    <div class="col-xs-12 col-sm-12 col-md-8">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_fleet">Fleet</label>\n' +
            '                                    <ui-select ng-model="vm.fleet" id="fleet_field" theme="bootstrap" on-select="vm.onFleetSelect($item)" style="z-index: 1000;">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a fleet...">\n' +
            '                                           {{$select.selected.fleetName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabFleets | filter: {fleetName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.fleetName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_objectType">Object Type</label>\n' +
            '                                       <ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search an object type...">\n' +
            '                                           {{$select.selected.objectTypeName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_status">Status</label>\n' +
            '                                    <ui-select ng-model="vm.status" id="field_status" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a status...">\n' +
            '                                           {{$select.selected.scheduleStatusName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.scheduleStatus | filter: {scheduleStatusName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.scheduleStatusName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_tag">Tag</label>\n' +
            '                                    <input type="text" class="form-control" name="tag" id="field_tag" ng_model="vm.tag"/>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                       <div class="row">\n' +
            '                           <div class="col-xs-10">\n' +
            '                               <div class="form-group">\n' +
            '                                   <label for="range">Range</label>\n' +
            '                                       <div class="input-group" id="range">\n' +
            '                                           <span class="input-group-addon" ng-click="vm.picker.start=true">FROM</span>\n' +
            '                                           <input type="text" id="start" class="form-control" ng-click="vm.picker.start=true" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.from" is-open="vm.picker.start"/>\n' +
            '                                           <span class="input-group-addon" ng-click="vm.picker.end=true">TO</span>\n' +
            '                                           <input type="text" id="end" class="form-control" ng-click="vm.picker.end=true" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.to" is-open="vm.picker.end"/>\n' +
            '                                       </div>\n' +
            '                                </div>\n' +
            '                           </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n',
            // '    </div>\n' ,
            // '</div>\n',
            controller: ScheduleFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    ScheduleFilterController.$inject = ['TabFleets', 'TabObjectTypes', 'TabScheduleStatus'];

    function ScheduleFilterController(TabFleets, TabObjectTypes, TabScheduleStatus) {
        var vm = this;
        vm.tabFleets = TabFleets.query();

        vm.tabFleets.$promise.then(function (data) {
            data.unshift(allFleet);
        });
        var mappedObjectType = {};

        TabObjectTypes.mapped(onSuccess, onError);

        function onSuccess (data) {
            mappedObjectType = JSON.parse(angular.toJson(data));
            mapObjectType();
            vm.tabObjectTypes = mappedObjectType[vm.fleet.id];
        }

        function onError() {}

        var allFleet = {
            id: -1,
            fleetName: 'All'
        };

        var allObjectType = {
            id: -1,
            objectTypeName: 'All'
        };

        var allScheduleStatus = {
            id: -1,
            scheduleStatusName: 'All'
        };

        vm.onFleetSelect = function (fleet) {
            vm.tabObjectTypes = mappedObjectType[fleet.id];
            vm.objectType = {};
            if (vm.tabObjectTypes.length > 0) {
                vm.objectType = allObjectType;
            }
        };

        vm.scheduleStatus = TabScheduleStatus.query();
        vm.statusFiltered = [];
        vm.scheduleStatus.$promise.then(function (data) {
            data.unshift(allScheduleStatus);
        });

        var it = JSON.parse(localStorage.getItem("first-access"));
        if(!it.firstAccess) {
            vm.fleet = allFleet;
            vm.objectType = allObjectType;
            vm.status =allScheduleStatus;
            vm.from = previousYear();
            vm.to = today();
            vm.tag = "";
        } else {
            vm.fleet = +vm.fleetVal() === -1 || +vm.fleetVal().id === -1 ? allFleet : vm.fleetVal();
            vm.objectType = +vm.objectTypeVal() === -1 || +vm.objectTypeVal().id === -1 ? allObjectType : vm.objectTypeVal();
            vm.status = +vm.statusVal() === -1 || +vm.statusVal().id === -1 ? allScheduleStatus : vm.statusVal();
            var filter = JSON.parse(localStorage.getItem("save-filter"));
            vm.from = new Date(filter.from);
            vm.to = new Date(filter.to);
            vm.tag =  filter.tag;
        }

        function mapObjectType() {
            for (var fleet in mappedObjectType) {
                if (mappedObjectType[fleet].length > 0) {
                    mappedObjectType[fleet].unshift(allObjectType);
                }
            }
        }
        function previousYear() {
            return new Date(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate());
        }

        function today(){
            return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
        }

        vm.submit = function () {
            var filter = {};
            filter.from = angular.copy(vm.from);
            filter.to = angular.copy(vm.to);
            filter.tag = angular.copy(vm.tag);
            localStorage.setItem('save-filter', JSON.stringify(filter));
            vm.filter({
                fleet: vm.fleet,
                objectType: vm.objectType,
                from: vm.from,
                to: vm.to,
                status: vm.status,
                tag: vm.tag
            });
        };
    }
})();
